import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import Indicator from '@/components/indicator'
import { storage, openNavUrl, c, getVuex } from '@/utils'
import router from '@/router'
import { customDomainAndLogo } from '@/config/automatic'
import store from '@/store'
import { stringify } from 'qs'

const CancelToken = axios.CancelToken

const getRequestConfigPageNum = (config) => {
  const nullAndUndefined = [null, undefined]
  const pageNum = !nullAndUndefined.includes(config['pageNum']) ? config['pageNum'] : config['PageNum']

  const skip = !nullAndUndefined.includes(config['skip']) ? config['skip'] : config['Skip']
  const page = !nullAndUndefined.includes(config['page']) ? config['page'] : config['Page']
  const paging = !nullAndUndefined.includes(config['Paging']) ? config['Paging'] : config['paging']
  const pageSkip = !nullAndUndefined.includes(config['paging.SkipCount'])
    ? config['paging.SkipCount'] : (
      !nullAndUndefined.includes(config['paging.skipCount']) ? config['paging.skipCount'] : (
        !nullAndUndefined.includes(config['Paging.SkipCount']) ? config['Paging.SkipCount'] : config['Paging.skipCount']
      )
    )
  let currentPage = null
  let pageSize = null
  let type = 'skip'
  if (!nullAndUndefined.includes(paging)) {
    currentPage = !nullAndUndefined.includes(paging['skipCount']) ? paging['skipCount'] : paging['SkipCount']
    pageSize = !nullAndUndefined.includes(paging['takeCount']) ? paging['takeCount'] : paging['TakeCount']
  } else if (!nullAndUndefined.includes(page)) {
    currentPage = page
    pageSize = config['size'] || config['Size']
    type = 'page'
  } else if (!nullAndUndefined.includes(skip)) {
    currentPage = skip
    pageSize = config['size'] || config['Size']
  } else if (!nullAndUndefined.includes(pageNum)) {
    currentPage = pageNum
    pageSize = config['pageSize'] || config['PageSize']
    type = 'page'
  } else if (!nullAndUndefined.includes(pageSkip)) {
    currentPage = pageSkip
    pageSize = config['paging.TakeCount'] || config['paging.takeCount'] || config['Paging.TakeCount'] || config['Paging.takeCount']
  }
  if (!nullAndUndefined.includes(currentPage)) {
    store.dispatch('setCurrentPage', { currentPage, pageSize, url: config.url, type })
  }
}

let instance = null

const baseUrl = '/insapi/v3'

const defaultOptions = {
  baseURL: baseUrl,
  method: 'get',
  timeout: 50000,
  cancelRepeatRequest: true // 是否取消重复请求
}

// 用来判断取消请求的标识
const REPEAT_REQUEST_TEXT = 'cancelRepeatRequest'
const pending = {}
const getRequestIdentify = (config) => {
  const { method = 'get', url, baseURL, data = '', params = '' } = config
  const sortedParams = stringify(params, { sort: (a, b) => a.localeCompare(b) })
  const sortedData = typeof data === 'object' ? stringify(data, { sort: (a, b) => a.localeCompare(b) }) : data
  const key = `${method.toLowerCase()}${baseURL}${url}${sortedParams}${sortedData}`
  return encodeURIComponent(key)
}
const removePending = (key, isRequest = false) => {
  if (Reflect.get(pending, key) && isRequest) {
    Reflect.get(pending, key).abort()
  }
  Reflect.deleteProperty(pending, key)
}
const service = axios.create({
  ...defaultOptions
})

const typeOf = (obj) => {
  return Object.prototype.toString.call(obj).slice(8, -1)
}

const string2Object = (str) => {
  if (typeOf(str) === 'String') {
    return str.split('&').reduce((prev, next) => {
      const [key, value] = next.split('=')
      prev[key] = value
      return prev
    }, {})
  }
  return str
}

service.interceptors.request.use(config => {
  const { data, params, url } = config
  if (data || params) {
    const _data = string2Object(data) || {}
    const _params = string2Object(params) || {}
    const _config = { url, ..._data, ..._params }
    getRequestConfigPageNum(_config)
  }
  // 实时出单监控 做特殊处理
  if (config.url !== '/report/getOutInsStatistics' && (config.showLoading === true || config.showLoading === undefined)) {
    Indicator.open()
  }
  return config
}, error => {
  return Promise.reject(error)
})

service.interceptors.response.use(response => {
  Indicator.close()
  return response
}, error => {
  Indicator.close()
  const { response } = error
  if (response) {
    const { status, data } = response

    if (!instance) {
      instance = Message({
        // Java错误响应可能使用Message或不返回描述，不能弹出空白/undefined提示。
        message: String((data && (data.message || data.Message || data.msg)) || '').trim() || '请求失败，请稍后重试',
        type: 'error',
        duration: 5000
      })
    }

    if (!['/login', '/404', '/403'].includes(location.pathname)) {
      const host = window.location.host
      const search = location.search

      let item = customDomainAndLogo.find(item => host.includes(item.subdomain))
      if (!item && (!search || !search.includes('?subdomain='))) { // 非jblsx的域名且search 不包含jblsx
        // openNavUrl(`/Home/LoginOut`, '', host, 'self')
      } else if (!item && search.includes('?subdomain=')) {
        item = customDomainAndLogo.find(item => item.subdomain === search.replace('?subdomain=', ''))
      }
      if ([403, 401].includes(status)) {
        const path = status === 401 ? (item ? item.path : '/login') : '/403'
        openNavUrl(path, '', host, 'self', false)
        return
      }
    }
  }
  return Promise.reject(error)
})

const defaultRequest = (config, requestId, resolve, reject) => {
  const { headers, ...rest } = config
  if (!headers) {
    config = rest
  }
  service(config)
    .then((res) => {
      removePending(requestId)
      resolve(res)
    })
    .catch((err) => {
      if (err.message !== REPEAT_REQUEST_TEXT) {
        removePending(requestId)
        reject(err)
      }
    })
}

const repeatRequest = (options) => {
  const config = { ...defaultOptions, ...options }
  const requestId = getRequestIdentify(config)
  config.requestId = requestId
  if (!config.cancelToken) {
    const source = CancelToken.source()
    config.source = source
    config.cancelToken = source.token
  }
  if (!config.cancelRepeatRequest) {
    return service(config)
  }

  if (!Reflect.get(pending, requestId)) {
    const requestObject = {}
    const promiseFn = new Promise((resolve, reject) => {
      requestObject.resolve = resolve
      requestObject.reject = reject
      requestObject.source = config.source

      defaultRequest(config, requestId, resolve, reject)
    })
    requestObject.promiseFn = promiseFn
    Reflect.set(pending, requestId, requestObject)
    return promiseFn
  }

  const { resolve, reject, promiseFn, source } = Reflect.get(pending, requestId)
  source.cancel(REPEAT_REQUEST_TEXT)
  Reflect.set(pending, requestId, { resolve, reject, promiseFn, source: config.source })
  defaultRequest(config, requestId, resolve, reject)
  return promiseFn
}

export const request = (options) => {
  return repeatRequest(options)
}

export default {
  base: (commit, options, mutation) => {
    const _token = router.currentRoute.query.token
    const __token = (options.params && options.params.headers) || c.getCookie('InsBackUserToken_V3')
    if (_token || __token) {
      if (['/sxcore/api', '/sxcore/basicLaw/api'].includes(options.baseURL)) { // 判断寿险接口
        options.headers = { ...options.headers, Authorization: _token || __token || '' }
      } else {
        options.headers = { ...options.headers, token: _token || __token || '' }
      }
    }
    if (!_token && !__token && process.env.NODE_ENV === 'development') {
      let token = storage.getItem('vuex')
      token = token && JSON.parse(token)
      if (['/sxcore/api', '/sxcore/basicLaw/api'].includes(options.baseURL)) { // 判断寿险接口
        options.headers = token && { ...options.headers, Authorization: token.commonData.token || token.auth.AUTH_LOGIN.data.token || '' }
      } else {
        options.headers = token && { ...options.headers, token: token.commonData.token || (token.auth.AUTH_LOGIN && token.auth.AUTH_LOGIN.data.token) || '' }
      }
    }
    // 登录验证码，写到 headers 里面
    if (options.headers && options.headers['rpa-logincheck']) {
      options.headers = { ...options.headers, 'rpa-logincheck': options.headers['rpa-logincheck'] }
    }
    // 灰度发布设置
    let gray = c.getCookie('gray') || ''
    if (gray) {
      options.headers = { ...options.headers, gray }
    }
    if (options.url.includes('insured?action=QueryInsuredPrice') && options.baseURL.includes('/insuredapi/api')) {
      const { token, ...rest } = options.headers
      options.headers = { ...rest }
    }

    options.baseURL = options.baseURL || baseUrl

    return new Promise((resolve, reject) => {
      request({ ...defaultOptions, ...options }).then(response => {
        return response
      }).then(({ data }) => {
        if (options.baseURL === '/proapi') { // 特殊处理获取当前软件的最新版本号
          const result = {
            data
          }
          resolve(result)
        } else {
          const { resultCode, Message, ResultCode, message, ...response } = data
          response.message = Message || message || ''
          // The insurance service uses UpperCamelCase while legacy APIs use camelCase.
          // Always expose one normalized resultCode to callers.
          response.resultCode = resultCode !== undefined ? resultCode : ResultCode
          // 兼容 UpperCamelCase 响应包络（BaseInfrastructureReply @JsonNaming）：Data -> data
          if (response.Data !== undefined && response.data === undefined) {
            response.data = response.Data
          }
          const { code, msg } = data
          if (+resultCode === 0 || +ResultCode === 0 || +code === 200) {
            const _data = response
            mutation && commit(mutation, _data)
            resolve(_data)
          } else if (ResultCode === undefined && resultCode === undefined && code === undefined) { // 银行卡信息
            mutation && commit(mutation, data)
            resolve(data)
          } else if (options.baseURL.indexOf('/openapi/') !== -1 && (+resultCode === 1 || +ResultCode === 1)) { // 针对点击量统计事件处理
            mutation && commit(mutation, response)
            resolve(response)
          } else if (options.url.indexOf('/rpa/login') !== -1 && (+resultCode === 1 || +ResultCode === 1)) { // 工号登录
            mutation && commit(mutation, response)
            resolve(response)
          } else if (+resultCode === 403) {
            const loginUser = getVuex('customer')['CUSTOMER_LOGINCUSTOMER']
            const partner = loginUser && loginUser.data && loginUser.data.Pratner
            const subdomain = (partner && partner.subdomain) || ''
            const item = customDomainAndLogo.find(item => item.subdomain === subdomain)
            if (item) {
              window.location.href = `${location.protocol}//${subdomain}.${item.domain}/page/login?redirect=${router.currentRoute.fullPath}`
            } else {
              router.replace({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
            }
          } else if (+resultCode === 2000000 || +ResultCode === 2000000) { // 针对联合登录的接口做特殊处理
            mutation && commit(mutation, data)
            resolve(data)
          } else if (+code === 711) { // 需要二次确认
            mutation && commit(mutation, data)
            resolve(data)
          } else {
            if (!options.needCustomMessage && (Message || message || msg || +resultCode === 1 || +ResultCode === 1)) {
              MessageBox.alert(String(Message || message || msg || '').trim() || '请求失败，请稍后重试')
              reject(Message || message)
            } else {
              resolve(data)
            }
          }
        }
      }).catch(error => {
        if (error.response && error.response.status === 506) { // 自定义code用于文件下载异常
          MessageBox.alert('输入验证码错误！')
        }
        reject(error)
      })
    })
  },
  pureDataCommit: (commit, data, mutation) => {
    return new Promise((resolve, reject) => {
      mutation && commit(mutation, data)
      const dataValue = (data && data.value) ? data.value : (data || '')
      resolve(dataValue)
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/base.js